export default __webpack_public_path__ + "static/lancamentos-campanha-a0f826304fb15ca2eeb063a4f2baaf50.jpg";